// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2816":"68297355","3202":"68297355","3639":"68297355","5599":"68297355","8475":"68297355","9008":"37d3fc1e"}[chunkId] + ".chunk.css";
};